import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse} from 'axios';
import { DashboardApi } from '../../../services';
import { IWaterSystemsData, WaterSystemsInitialState } from '../waterSystems.slice'

export const fetchWaterSystemsAsync = createAsyncThunk(
    'systems/fetchSystems',
    async ({ zips }: { zips: string },
   { rejectWithValue },) => {
      try {
        const response = await DashboardApi.fetchWaterSystems(zips);
        return (response as AxiosResponse<any,any>).data;
      } catch (error: any) {
        console.error(error);
        return rejectWithValue({
          message: error?.response?.data?.message || "Unexpected error occurred"
        });
      }
    }
  );

export const fetchWaterSystemsAsyncBuilder = (
    builder: ActionReducerMapBuilder<WaterSystemsInitialState>
  ) => {
    builder.addCase(fetchWaterSystemsAsync.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = '';
    })
    builder.addCase(
      fetchWaterSystemsAsync.fulfilled,
      (state, action: PayloadAction<IWaterSystemsData>) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      }
    )
    builder.addCase(
      fetchWaterSystemsAsync.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      }
    )
  }